import React from "react";
import { Row, Col } from "react-bootstrap";
import { formatUSD, formatPercentage } from "../../utils/format";
import DetailsRow from "../DetailsRow";
import useGenericCall from "../../hooks/useGenericCall";
import { useOnchainAccountLendingPool } from "../../hooks/useOnchain";

/**
 * Generates lending pool aggregate details.
 */
export default function AccountLendingPoolDetailsEarnInterest() {
  const data = useGenericCall(
    useOnchainAccountLendingPool(),
    async (onchainAccountLendingPool) => {
      return {
        suppliedUSD: await onchainAccountLendingPool.getSuppliedUSD(),
        accountAPR: await onchainAccountLendingPool.getAccountAPR(),
      };
    }
  );

  if (!data) return null;

  return (
    <>
      <Row className="account-lending-pool-details">
        <Col sm={12} md={6}>
          <DetailsRow
            name="Supply Balance"
            value={formatUSD(data.suppliedUSD)}
          />
        </Col>
        <Col sm={12} md={6}>
          <DetailsRow
            name="Net APR"
            value={formatPercentage(data.accountAPR)}
          />
        </Col>
      </Row>
    </>
  );
}
